/* Page pré-funnel « Tiloa Duck » — comportements de la page.

   Trois choses, rien de plus :
     1. les accordéons de la FAQ ;
     2. le CTA flottant mobile ;
     3. la propagation des paramètres d'URL vers la fiche produit.

   Aucun suivi publicitaire n'est ajouté ici : on ne pose aucun cookie, on ne
   charge aucun pixel et on ne touche pas au consentement. Les paramètres sont
   simplement recopiés d'une URL vers l'autre, comme le ferait un lien écrit
   à la main.
*/
(function () {
  'use strict';

  /* ---------- 1. FAQ ---------- */
  document.querySelectorAll('.gp-faq__q').forEach(function (q) {
    q.addEventListener('click', function () {
      var ouvert = q.getAttribute('aria-expanded') === 'true';
      q.setAttribute('aria-expanded', ouvert ? 'false' : 'true');
      var panneau = document.getElementById(q.getAttribute('aria-controls'));
      if (panneau) panneau.hidden = ouvert;
    });
  });

  /* ---------- 2. Paramètres conservés vers la fiche produit ----------

     On recopie les utm_*, les identifiants de clic connus (Pinterest, Google,
     Facebook) et tout ce que la publicité a déjà posé, puis on ajoute
     funnel=presell pour distinguer ce parcours du parcours direct.
     Un paramètre déjà présent sur le lien n'est jamais écrasé. */
  var entree = new URLSearchParams(window.location.search);
  var aGarder = [];
  entree.forEach(function (valeur, cle) {
    if (/^utm_/i.test(cle) || /^(epik|pp|pinterest_|gclid|fbclid|ttclid|msclkid|srsltid)/i.test(cle)) {
      aGarder.push([cle, valeur]);
    }
  });

  document.querySelectorAll('[data-gp-cta]').forEach(function (lien) {
    var href = lien.getAttribute('href');
    if (!href) return;
    var url;
    try { url = new URL(href, window.location.origin); } catch (e) { return; }
    // On reste sur la boutique : pas de recopie de paramètres vers l'extérieur.
    if (url.origin !== window.location.origin) return;
    aGarder.forEach(function (p) { if (!url.searchParams.has(p[0])) url.searchParams.set(p[0], p[1]); });
    if (!url.searchParams.has('funnel')) url.searchParams.set('funnel', 'presell');
    lien.setAttribute('href', url.pathname + url.search + url.hash);
  });

  /* ---------- 3. CTA flottant mobile ----------

     Il apparaît une fois le hero passé et s'efface près du CTA final, pour ne
     pas doubler un bouton déjà visible. La mesure se fait dans un rAF : un
     IntersectionObserver ne se déclenche pas quand un élément traverse tout
     l'écran en un seul défilement. */
  var barre = document.querySelector('[data-gp-sticky]');
  if (!barre) return;
  var repere = document.querySelector('[data-gp-sticky-after]');
  var fin = document.querySelector('[data-gp-sticky-until]');
  var enAttente = false;

  function maj() {
    enAttente = false;
    var depasse = repere ? repere.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
    var arrive = fin ? fin.getBoundingClientRect().top < window.innerHeight * 0.9 : false;
    barre.classList.toggle('is-visible', depasse && !arrive);
  }
  function planifier() {
    if (enAttente) return;
    enAttente = true;
    window.requestAnimationFrame(maj);
  }
  window.addEventListener('scroll', planifier, { passive: true });
  window.addEventListener('resize', planifier, { passive: true });
  maj();

  /* La bannière de consentement est prioritaire : tant qu'elle est affichée,
     le CTA flottant se range au-dessus d'elle plutôt que de la recouvrir. */
  function suivreBanniere() {
    var dlg = document.querySelector('.shopify-pc__banner__dialog');
    var h = 0;
    if (dlg) {
      var cs = getComputedStyle(dlg);
      var r = dlg.getBoundingClientRect();
      if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0 && r.bottom > window.innerHeight - 80) {
        h = Math.round(window.innerHeight - r.top) + 8;
      }
    }
    barre.style.bottom = h ? h + 'px' : '';
  }
  suivreBanniere();
  if (document.body) {
    new MutationObserver(suivreBanniere).observe(document.body, { childList: true, subtree: true });
  }
  window.addEventListener('resize', suivreBanniere, { passive: true });
})();
